/**
 * Engagement Tool
 *
 * Tool definition for the Visitor Engagement dashboard.
 * Tracks anonymous homepage sessions, slider use, CTA clicks, and quote submissions.
 */

import { FaChartLine } from 'react-icons/fa';
import { BaseTool } from '../BaseTool';

export class EngagementTool extends BaseTool {
  constructor() {
    super();

    this.id          = 'engagement';
    this.name        = 'Engagement';
    this.description = 'Homepage visitor sessions, funnel analytics, and real-time activity';
    this.icon        = FaChartLine;
    this.color       = '#6366f1'; // indigo

    this.path = '/dashboard/tools/engagement';

    this.collections = ['engagement', 'nextgen_quote_index'];

    this.requiresAdmin = false;

    this.summaryConfig = {
      enabled: true,
      mainStat: 'sessionsToday',
      expectedStatCount: 3,
    };
  }

  /**
   * Get summary data for the dashboard card.
   * Engagement data is client-side only (no API), so we return a placeholder.
   * Real stats are shown on the full page via the Firestore hooks.
   */
  async getSummaryData() {
    return {
      success: true,
      data: {
        sessionsToday: null,
        liveNow: null,
        quotesTotal: null,
      },
      lastUpdated: new Date(),
    };
  }
}

export default EngagementTool;
